module.exports = __webpack_public_path__ + "img/di_gasell_new2015_FB.b6d995b2.png";